import React, { useEffect, useState } from "react";
import Sidebaar from "../Component/Sidebar";
import TitleComp from "../Component/TitleComp";
import { Button, Col, Modal } from "react-bootstrap";
import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { Base_Url } from "../BaseUrl";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

function PlansList() {
  const [planlist, setplanlist] = useState([]);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
    };
    const [imageurl, setimageurl] = useState("")


    const [show, setShow] = useState(false);
  
    const handleClose = () => setShow(false);
    const handleShow = (e, value) => {
      setShow(true)
      setimageurl(value)
    };

  const columns = [
    { field: "name", headerName: "Name", flex: 1 },
    {
      field: "code",
      headerName: "Code",
      flex: 1,
    },
    {
      field: "image",
      headerName: "image",
      flex: 1,
      renderCell: (params) => {
        const { value } = params;
        return (
          <img
            src={`${Base_Url}/${value}`}
            onClick={(e)=>handleShow(e , value)}
            style={{
              width: "45px",
              height: "45px",
              borderRadius: "50%",
            }}
            className="img-fluid tableimgmui"
          ></img>
        );
      },
    },

    {
      field: "edit",
      headerName: "Edit",
      flex: 1,
      renderCell: (params) => {
        const index = params.row.index; // Corrected to rowIndex
        return (
          <span
            style={{ cursor: "pointer" }}
            onClick={(e) => handleedit(e, index)}
          >
            <i className="fa-solid fa-pen-to-square"></i>
          </span>
        );
      },
    },
    {
      field: "delete",
      headerName: "Delete",
      flex: 1,
      renderCell: (params) => {
        const index = params.row.index;
        const id = params.row._id; // Corrected to rowIndex
        return (
          <span
            style={{ cursor: "pointer" }}
            onClick={(e) => {
              handleDelete(e, id);
            }}
          >
            <i class="fa-solid fa-trash"></i>
          </span>
        );
      },
    },
  ];


  const notify = (message, type) => {
    // console.log("type", type);
    toast[type](message, {
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };
  
  
  
  const handleDelete = (e, id) => {
    e.preventDefault();
  
    let requestdata = {
      _id: id,
      deleted_at: Math.floor(Date.now() / 1000),
    };
  
    axios
      .put(`${Base_Url}/plans`, requestdata, { headers })
      .then((res) => {
        // console.log(res);
        if (res.data.message === "Ok") {
          handleget()
          notify("Delete Successfully", "success");
          // console.log("Data", res.data);
        }
      })
      .catch((error) => {
        console.error("Error deleting:", error);
        notify("Error deleting", "error");
      });
  };

  const handleedit = (e, index) => {
    e.preventDefault();
    navigate(`/planning/${index}`);
  };

  const getRowId = (row) => row._id;

  const handleget = (e) => {
    axios.get(`${Base_Url}/plans`, { headers }).then((res) => {
      setplanlist(res.data.data);
    });
  };
  useEffect(() => {
    handleget();
  }, []);

  return (
    <>
      <Sidebaar
        content={
          <>
            <TitleComp title="Plans List" />
            <Col md="12">
              <Box sx={{ height: 500, width: "100%" }}>
                <DataGrid
                  //   rows={data} // Update this line
                  rows={planlist.map((row, index) => ({
                    ...row,
                    index,
                  }))}
                  columns={columns}
                  pageSize={5}
                  getRowId={getRowId}
                  initialState={{
                    pagination: { paginationModel: { pageSize: 10 } },
                  }}
                  pageSizeOptions={[5, 10, 25]}
                />
              </Box>
            </Col>
            <ToastContainer/>


            
            <Modal show={show} size="md" onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>Image</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <img src={`${Base_Url}/${imageurl}`} alt="" />
              </Modal.Body>
              <Modal.Footer>
                <Button className="text-write bg-secondary  shadow-none border-0" onClick={handleClose}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        }
      />
    </>
  );
}

export default PlansList;
